<template>
  <template v-if="mode === 'edit'">
    <div
      :class="[
        'py-2 radio-field',
        field.error
          ? 'my-2 px-2 rounded border-2 border-brand-red bg-brand-red bg-opacity-10'
          : ''
      ]"
      :name="field.name"
      :field-id="field.field_id"
      :required="field.required"
    >
      <!-- alert container -->
      <label v-if="field.label" for="input" class="block">
        {{ field.label }}
        <span v-if="field.required" class="text-brand-red">*</span>
      </label>
      <div
        v-for="(choice, index) in field.choices"
        :key="`choice-${index}`"
        class="flex items-center py-1"
      >
        <label
          :for="`${field.name}-radio-option-${index}`"
          class="inline-flex items-center"
        >
          <input
            :name="`${field.name}-radio-group`"
            :id="`${field.name}-radio-option-${index}`"
            type="radio"
            class="border-gray-300 text-brand-green focus:ring-brand-green"
            @change="updateValue(choice)"
            :value="choice.label"
            v-model="selected"
          />
          <span class="ml-3 block text-brand-black">{{
            choice.label
          }}</span></label
        >
      </div>

      <template v-if="field.help_text">
        <p class="text-brand-mid-gray italic text-xs">{{ field.help_text }}</p>
      </template>

      <template v-if="field.error">
        <p class="text-brand-red py-1">{{ errorMessage }}</p>
      </template>
    </div>
  </template>
  <template v-else-if="mode === 'view'"> </template>
  <template v-else-if="mode === 'form_edit'">
    <div class="flex flex-col w-full">
      <div
        v-for="(choice, index) in field.choices"
        :key="`choice-${index}`"
        class="flex items-center py-1"
      >
        <label
          :for="`${field.name}-radio-option-${index}`"
          class="inline-flex items-center"
        >
          <input
            :name="`${field.name}-radio-group`"
            :id="`${field.name}-radio-option-${index}`"
            type="radio"
            class="border-gray-300 text-brand-green focus:ring-brand-green"
            disabled
          />

          <div class="px-2">
            <TextDisplayEditToggle
              :helpText="choice.label"
              :type="'field_label'"
              @input="updateChoiceLabel(index, $event)"
              :disabled="field.editable === false"
            />
          </div>
        </label>
        <XIcon
          class="text-brand-red w-5 h-5 ml-1 cursor-pointer"
          @click="removeOption(index)"
        />
      </div>
      <div class="flex items-center py-2">
        <div class="flex cursor-pointer items-center" @click="addOption">
          <PlusIcon class="text-brand-green w-4 h-4 mr-1" />
          <p class="text-brand-green text-sm">Add</p>
        </div>
      </div>
      <TextDisplayEditToggle
        :helpText="field.help_text"
        :type="'field_subtext'"
        @input="updateHelpText"
        :disabled="field.editable === false"
      />
    </div>
  </template>
</template>
<script>
import _ from "lodash"

import { PlusIcon, XIcon } from "@heroicons/vue/outline"

export default {
  components: {
    PlusIcon,
    XIcon
  },
  props: {
    field: Object,
    mode: {
      type: String
    },
    stage: {
      type: String
    }
  },
  emits: ["update"],
  computed: {
    isValid() {
      if (this.field.required && !this.field.value) {
        return false
      }
      return true
    }
  },
  mounted() {
    if (this.field.value) {
      this.selected = this.field.value
    }
  },
  data() {
    return {
      selected: null,
      errorMessage: ""
    }
  },
  methods: {
    updateChoiceLabel(choiceIndex, ev) {
      const choice = this.field.choices[choiceIndex]
      choice.label = ev.target.value
    },
    updateHelpText(ev) {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.help_text = ev.target.value
    },
    removeOption(index) {
      // eslint-disable-next-line vue/no-mutating-props
      _.pullAt(this.field.choices, index)
    },
    addOption() {
      // eslint-disable-next-line vue/no-mutating-props
      this.field.choices = [
        ...this.field.choices,
        {
          value: `option-${this.field.choices.length + 1}`,
          label: `Option ${this.field.choices.length + 1}`
        }
      ]
    },
    updateValue() {
      this.$emit("update", this.selected)
    },
    validateField() {
      if (!this.isValid) {
        if (this.field.required && !this.field.value) {
          this.errorMessage = "This field is required."
        }
      } else {
        this.errorMessage = ""
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// Remove white circle when checked and make ring persist
[type="radio"]:checked {
  background-image: none;
  @apply ring-2 ring-offset-2 ring-brand-green;
}
</style>
